import * as Sentry from '@sentry/react';
import {
  captureWindowErrors,
  fromSentryEvent,
  frontendErrorStore,
} from './frontend-error-store';

/**
 * Starts to record frontend errors and warnings for the developer dashboard.
 * When Sentry runs, the dashboard gets the same events that go to Sentry, including warnings
 * from `Sentry.captureMessage`. Without Sentry (local development), it records uncaught
 * errors and unhandled promise rejections from the window.
 */
export const installFrontendErrorCapture = (): void => {
  if (Sentry.isInitialized()) {
    Sentry.addEventProcessor((event) => {
      const entry = fromSentryEvent(event);
      if (entry) frontendErrorStore.add(entry);
      return event;
    });
    return;
  }

  captureWindowErrors(window, frontendErrorStore);
};
